



































import { Component, Vue, PropSync } from 'vue-property-decorator'
import { ReportType } from '@/domain/ReportType'
import ReportTypesService from '@/service/ReportTypesService'

@Component
export default class ReportTemplateDialogComponent extends Vue {
  reportTypesService = ReportTypesService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "報告書テンプレート名", value: "name" },
  ]
  itemsPerPage = 10
  /** データテーブル フッター設定 */
  footerProps = {
    'disable-items-per-page': true,
    showFirstLastPage: true,
    firstIcon: 'mdi-skip-backward',
    lastIcon: 'mdi-skip-forward',
    prevIcon: 'mdi-skip-previous',
    nextIcon: 'mdi-skip-next'
  }
  list: ReportType[] = []
  selected: ReportType[] = []

  mounted () {
    this.reportTypesService.findAll().then(x => this.list = x)
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.selected[0])
  }
}
